import {
  IconButton,
  Checkbox,
  HStack,
  Box,
  Tooltip,
  useDisclosure
} from '@chakra-ui/react'
import { FC, memo, useCallback, useMemo, useState, useEffect } from 'react'
import Highlighter from 'react-highlight-words'
import { BsCalculator } from 'react-icons/bs'

import useMrpReab from '@hook/mrp/use-reab'
import useTable from '@hook/shared/use-table'

import CalculoDetalheModal from '@component/Modules/Mrp/Modals/CalculoDetalhe'

import { ITableGridRow } from '@base/@types/components/Layout/TableGrid'

const TableGridReabMrp: FC<{
  [key: string]: any
  [indexData: number]: number
}> = memo(({ data }) => {
  const { actions, columns, query } = useTable()
  const { handleUpdateWanted } = useMrpReab()
  const [wanted, setWanted] = useState(0)
  const {
    isOpen: isCalculoOpen,
    onOpen: onCalculoOpen,
    onClose: onCalculoClose
  } = useDisclosure()
  /*
  useEffect(() => {
    const timeout = setTimeout(() => {
      if (wanted !== 0) {
        handleUpdateWanted(data['produto-id'], wanted)
        setWanted(0)
      }
    }, 2000)
    return () => {
      clearTimeout(timeout)
    }
  }, [handleUpdateWanted, wanted, indexData, setWanted, data])
*/
  const rows = useMemo<ITableGridRow[]>(() => {
    const res = []
    for (const column of columns) {
      if (column.columns && column.columns.length > 0) {
        for (const row of column.columns) {
          res.push({
            id: row.id,
            value: data[row.id],
            align: row.align || 'left',
            isNumeric: row.isNumeric
          })
        }
      } else {
        res.push({
          id: column.id!,
          value: data[column.canPrint ? column.id! : column.group],
          align: column.align || 'left'
        })
      }
    }
    return res
  }, [columns, data])

  const handleBlur = useCallback(
    (e: number) => {
      handleUpdateWanted(data['produto-id'], e)
    },
    [handleUpdateWanted, data]
  )

  useEffect(() => {
    const timeout = setTimeout(() => {
      if (wanted !== 0) {
        setWanted(0)
      }
    }, 2000)
    return () => {
      clearTimeout(timeout)
    }
  }, [wanted, setWanted])

  return (
    <tr>
      {actions && actions.length > 0 && (
        <td>
          <HStack
            spacing={2}
            w="100%"
            alignItems="center"
            justifyContent="center"
          >
            {actions.map((action, index) => {
              if (action.type === 'icon') {
                return (
                  <IconButton
                    key={`table-action-${index}`}
                    aria-label="Abrir modal"
                    icon={action.icon}
                    size="xs"
                    onClick={() => action.onSelect!(data)}
                    _hover={{
                      bg: 'yellow.200'
                    }}
                    _active={{
                      bg: 'yellow.100'
                    }}
                  />
                )
              }

              if (action.type === 'iconCalculo') {
                const etapasSaida: string[] = data['calculo-saida-diaria'] || []
                const etapasQuantidade: string[] =
                  data['calculo-quantidade'] || []
                const temDados =
                  etapasSaida.length > 0 || etapasQuantidade.length > 0

                return (
                  <>
                    <CalculoDetalheModal
                      isOpen={isCalculoOpen}
                      onClose={onCalculoClose}
                      produto={String(data['produto-id'])}
                      centro={String(data['centro-id'])}
                      etapasSaida={etapasSaida}
                      etapasQuantidade={etapasQuantidade}
                    />
                    <Tooltip
                      key={`table-action-${index}`}
                      label="Detalhamento do cálculo"
                      placement="top"
                      fontSize="xs"
                      hasArrow
                    >
                      <IconButton
                        aria-label="Detalhamento do cálculo"
                        icon={<BsCalculator />}
                        size="xs"
                        variant="ghost"
                        color={temDados ? '#1d5840' : 'gray.300'}
                        onClick={onCalculoOpen}
                        _hover={{ bg: '#1d584018', color: '#1d5840' }}
                        _active={{ bg: '#1d584030' }}
                      />
                    </Tooltip>
                  </>
                )
              }

              if (action.type === 'checkbox') {
                if (action.isMulti) {
                  return (
                    <Checkbox
                      key={`table-action-${index}`}
                      colorScheme="red"
                      isChecked={action.selecteds.includes(data['id-id'])}
                      borderColor="blackAlpha.400"
                      alignItems="center"
                      onChange={() => {
                        if (action.onChange) {
                          action.onChange(data)
                        }
                      }}
                    />
                  )
                } else {
                  return (
                    <Checkbox
                      key={`table-action-${index}`}
                      colorScheme="yellow"
                      isChecked={action.isChecked}
                      borderColor="blackAlpha.400"
                      alignItems="center"
                      isDisabled={
                        action.selecteds !== 0
                          ? action.selecteds !== data['id-id']
                          : false
                      }
                      onChange={() => {
                        if (action.onChange) {
                          action.onChange(data)
                        }
                      }}
                    />
                  )
                }
              }
            })}
          </HStack>
        </td>
      )}
      {rows.map(({ id, value, align, isNumeric }, key) => (
        <td
          id={id}
          key={`${id}-${key}`}
          align={align || 'left'}
          className={
            id === 'estoque-quantidade-sugerida'
              ? 'custom td-element'
              : 'td-element'
          }
        >
          {(() => {
            if (id === 'estoque-quantidade-sugerida') {
              return (
                <div
                  contentEditable
                  onBlurCapture={e =>
                    handleBlur(Number(e.currentTarget.textContent))
                  }
                >
                  {query.length > 0 ? (
                    <Highlighter
                      searchWords={String(query).split(' ')}
                      textToHighlight={String(value)}
                    />
                  ) : (
                    value
                  )}
                </div>
              )
            } else {
              return (
                <div>
                  <Box
                    justifyContent={isNumeric ? 'center' : null}
                    textAlign={isNumeric ? 'center' : null}
                  >
                    {query.length > 0 ? (
                      <Highlighter
                        searchWords={String(query).split(' ')}
                        textToHighlight={String(value)}
                      />
                    ) : (
                      value
                    )}
                  </Box>
                </div>
              )
            }
          })()}
        </td>
      ))}
    </tr>
  )
})

TableGridReabMrp.displayName = 'TableGridReabMrp'

export default TableGridReabMrp
